import React from "react";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { Card, Row, Space, ProgressBar } from "@masterteam/mt-design-react";
import useIsAr from "../../../Hooks/useIsAr";


import "./style.scss";
import Projects from "./Projects";
import ProjectStatus from "./ProjectStatus";

const InitiativeCard = ({ data, statuses, projectStatuses }) => {
  const [isAr] = useIsAr();
  const intl = useIntl();
  const history = useHistory();

  const status = statuses?.find((e) => e.Code === data?.Status);
  const plannedStatus = statuses?.find((e) => e.Code === data?.PlannedStatus);
  const handleClick = () => {
    const currentPath = window.location.hash.slice(1);
    const newPath = `${currentPath}/initiatives/${data.ID}`;
    history.push(newPath);
  };
  return (
    <Card className="initiative-card-wrapper" onClick={handleClick}>
      <Row className="title">{isAr ? data.ArabicName : data.EnglishName}</Row>

      <Row className="items-wrapper">
        <Space size="medium">
          <Space direction="vertical" size="small" className="item">
            <div className="value">
              {data?.ManagerModel?.DisplayName || "---"}
            </div>
            <div className="label">
              {intl.formatMessage({
                id: "project.initiative-manager",
              })}
            </div>
          </Space>
        
        </Space>
        <Space direction="vertical" size="small" className="item">
        <ProjectStatus color={status?.Color} label={isAr? status?.ArabicName: status?.EnglishName}/>
          </Space>
       
      </Row>

      <Row className="progress" gap="5px">
        <ProgressBar
          value={data?.Progress}
          color={status?.Color}
          title={intl.formatMessage({
            id: "common.actual-progress",
          })}
        />
          <span style={{ color: status?.Color, paddingTop: 22, width: 65 }}>% {data?.Progress}</span>
      </Row>

      <Row className="progress" gap="5px">
        <ProgressBar
          value={data?.PlannedProgress}
          title={intl.formatMessage({
            id: "common.planned-progress",
          })}
        />
       <span style={{ color: status?.Color, paddingTop: 22, width: 65 }}>% {data?.PlannedProgress}</span>
      </Row>

      <Row className="details" justify="between">
        <Space direction="vertical" className="item">
        <div>
            {intl.formatMessage({
              id: "common.projects",
            })} {" "} {`(${data?.ProjectLEDChart?.Count||0})`}
          </div>
          <Projects data={data?.ProjectLEDChart?.ChartData || []} projectStatuses={projectStatuses}/>
        
        </Space>

       

     
      </Row>
    </Card>
  );
};

export default InitiativeCard;
